import React from "react";
import { Nav } from "react-bootstrap";
import { useLocation } from "react-router-dom";

import { ReactComponent as HomeIcon } from "../../app/assets/icons/leftnav/home-icon.svg";
import { ReactComponent as ProvisioningIcon } from "../../app/assets/icons/leftnav/provisioning-icon.svg";
import { useLeftnavOptions } from "../../hooks/useLeftnavOptions";
import NavLink from "../../components/Navlink/Navlink";
import useWindowSize from "../../hooks/useWindowSize";
import { useAppDispatch, useAppSelector } from "../../redux/store";
import { toggleSidebarCollapse } from "../../redux/slice/nonPersist/sidebarSlice";
import "../Leftnav/leftnav.scss";

const iconMap: Record<string, JSX.Element> = {
  Home: (
    <HomeIcon
      data-tooltip-html={"<div class='label-tooltip'>Home</div>"}
      data-tooltip-id="tooltip-Home"
      data-tooltip-delay-hide={0}
    />
  ),
  Provisioning: (
    <ProvisioningIcon
      data-tooltip-html={"<div class='label-tooltip'>Home</div>"}
      data-tooltip-id="tooltip-Home"
      data-tooltip-delay-hide={0}
    />
  ),
};

const LeftnavCollapsed = () => {
  const location = useLocation();
  const currentLocation = location.pathname.split("/").slice(0, 2).join("/");

  const filteredLeftnavOptions = useLeftnavOptions();
  const { width } = useWindowSize();

  const { isCollapsed } = useAppSelector((state) => state.sidebar);

  const dispatch = useAppDispatch();

  return (
    <>
      <Nav
        className="flex-column w-100 flex-nowrap left-nav"
        style={{
          height: "fit-content",
        }}
        id="leftnav2"
      >
        {filteredLeftnavOptions?.map((eachMenuitem) => {
          const isActive =
            (eachMenuitem.path as string).includes(currentLocation) &&
            currentLocation !== "/";
          return (
            <>
              {eachMenuitem?.children ? (
                <div
                  onClick={(e) => {
                    dispatch(toggleSidebarCollapse());
                  }}
                  className={`py-1 nav-link-item ${isCollapsed ? "collapsed-menu" : ""}`}
                  id={eachMenuitem?.label}
                >
                  <div
                    className={` ${isActive ? "link active" : ""} ${isCollapsed ? "w-90" : "w-100"}`}
                    id="navlink"
                  >
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="d-flex">
                        {isActive && (
                          <div
                            className={`${width < 992 ? "thick-line-medium-screen" : "thick-line"}`}
                          ></div>
                        )}
                        <div
                          className={
                            isActive
                              ? `side-header side-header-active`
                              : `side-header ms-3`
                          }
                        >
                          {/* <TooltipContainer
                          id={`tooltip-${eachMenuitem.label}`}
                          place="right"
                          className="bg-white text-black p-0 m-0"
                          style={{ zIndex: 3 }}
                          offset={5}
                        > */}
                          {iconMap[eachMenuitem?.label]}
                          {/* </TooltipContainer> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <>
                  <NavLink
                    path={eachMenuitem?.path as string}
                    icon={
                      // <TooltipContainer
                      //   id={`tooltip-${eachMenuitem.label}`}
                      //   place="right"
                      //   className="bg-white text-black p-0 m-0"
                      //   style={{ zIndex: 3 }}
                      //   offset={5}
                      // >
                      iconMap[eachMenuitem.label]
                      /* </TooltipContainer> */
                    }
                    // onClick={() => {
                    //   dispatch(
                    //     setSecondSidebarDetails({
                    //       sidebarDetailsLabel: "",
                    //     }),
                    //   );
                    // }}
                  />
                </>
              )}
            </>
          );
        })}
      </Nav>
    </>
  );
};

export default LeftnavCollapsed;
